import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { RolesPermissionsService } from '../services/roles-permissions.service';
import { GlobalService } from '../services/global.service';
import { LoaderService } from '../loader/loader.service';

export const FGUserGuard: CanActivateFn = () => {
  const rolesService = inject(RolesPermissionsService);
  const globalService = inject(GlobalService);
  const loader = inject(LoaderService);
  const router = inject(Router);
  if(!globalService.isBusinessUnitSelected()) {
    router.navigate(['select-business-unit']);
    return false;
  }
  const hasAccess = rolesService.hasPermission('FinishedGoodsTab', 'VIEW')

  if (hasAccess) {
    loader.setLoadingState.set(true)
    return true;
  } else {
    return false;
  }
};
